import { gql, useMutation } from '@apollo/client'
import { UpdateCartMutation, UpdateCartMutationVariables } from 'types/graphql'
import { cartFieldsFragment } from './cartFieldsFragment'

const mutation = gql`
  ${cartFieldsFragment}

  mutation UpdateCart($id: ID!, $productVariants: [CartSkuUpdateInput!]!) {
    updateCart(id: $id, productVariants: $productVariants) {
      ...CartFields
    }
  }
`

export const useUpdateCart = () => {
  return useMutation<UpdateCartMutation, UpdateCartMutationVariables>(mutation)
}
